var React = require('react');

function Book03 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.42935 1.7998V16.1998M13.1151 7.97123H9.51507M13.1151 4.88552H9.51507M3.85792 4.88552H1.80078M3.85792 7.97123H1.80078M3.85792 11.0569H1.80078M4.88649 16.1998H14.1436C15.2798 16.1998 16.2008 15.2788 16.2008 14.1427V3.85695C16.2008 2.72082 15.2798 1.7998 14.1436 1.7998H4.88649C3.75037 1.7998 2.82935 2.72082 2.82935 3.85695V14.1427C2.82935 15.2788 3.75037 16.1998 4.88649 16.1998Z","stroke":"currentColor","strokeLinecap":"round"}));
}

Book03.defaultProps = {"width":"20","height":"20","viewBox":"0 0 18 18","fill":"none"};

module.exports = Book03;

Book03.default = Book03;
